<template>
    <div class="view-container">
        <template v-for="item in swipeList">
            <div v-if="item.swipeType === 'module'" class="module-view" :key="item.uid">
                <div class="container">
                    <div class="title">
                        <span>{{ item.unit }}</span> {{ item.title }}
                    </div>
                    <TextTemplate class="subtitle" v-if="item.subtitle" :text="item.subtitle" />
                </div>
            </div>
            <div
                :ref="`question${item.indexNo}`"
                v-else-if="item.swipeType === 'question'"
                :key="`question-${item.uid}`"
            >
                <Choice
                    :show="true"
                    :question="item.question"
                    v-if="['SINGLE_CHOICE', 'JUDGMENT'].includes(item.type)"
                />
                <MuletpleChoice :show="true" :question="item.question" v-if="item.type === 'MULTIPLE_CHOICE'" />
                <Blank
                    :show="true"
                    :question="item.question"
                    v-if="['DISORDER_BLANK', 'ORDER_BLANK'].includes(item.type)"
                />
                <Writing :show="true" :question="item.question" v-if="item.type === 'WRITING'" />
                <ComplexPc :question="item.question" v-if="complexTypes.includes(item.type)" />
            </div>
        </template>
    </div>
</template>
<script>
import TextTemplate from '../TextTemplate.vue'
import Choice from './question/Choice.vue'
import MuletpleChoice from './question/MuletpleChoice.vue'
import Blank from './question/Blank.vue'
import ComplexPc from './question/ComplexPc.vue'
import Writing from './question/Writing.vue'
import { mapGetters } from 'vuex'

export default {
    components: { TextTemplate, Choice, MuletpleChoice, Blank, Writing, ComplexPc },
    computed: {
        ...mapGetters(['userInfo']),
        config() {
            return this.$store.state.paperDetails.config
        },
        jumpQuestion() {
            return this.$store.state.paperDetails.jumpQuestion
        },
        complexTypes() {
            return this.$store.state.paperDetails.complexTypes
        },
        moduleList() {
            return this.$store.state.paperDetails.moduleList
        },
        swipeList()  {
            const list = []
            this.moduleList.forEach((mItem) => {
                list.push({
                    swipeType: 'module',
                    uid: `module${mItem.id}`,
                    title: mItem.title,
                    subtitle: mItem.subtitle,
                    unit: mItem.unit,
                })
                mItem.questions.forEach((item) => {
                    list.push({
                        swipeType: 'question',
                        uid: `module${item.id}`,
                        id: item.id,
                        type: item.type,
                        indexNo: item.indexNo,
                        question: item,
                        hasChildren: item.childQuestions && item.childQuestions.length !== 0,
                    })
                })
            })
            return list
        },
    },

    watch: {
        jumpQuestion: function () {
            this.swipeList.forEach((item) => {
                if (this.jumpQuestion.questionId === item.id) {
                    if (this.$refs[`question${item.indexNo}`][0]) {
                        this.$refs[`question${item.indexNo}`][0].scrollIntoView({
                            block: 'start', // 元素顶部与视口顶部对齐
                        })
                    }
                }
            })
        },
    },
}
</script>
<style lang="scss">
.view-container {
    .list {
        display: flex;
        flex-wrap: wrap;
        .item {
            width: 50%;
        }
    }
}
.module-view {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    .container {
        flex-grow: 1;
        .title {
            padding: 60px 20px 12px;
            text-align: center;
            font-size: 18px;
            font-weight: 700;
        }
        .subtitle {
            padding: 0 40px;
            overflow-y: auto;
            font-size: 14px;
            color: #999;
            line-height: 1.4em;
        }
    }
}
</style>
